module.exports = __webpack_public_path__ + "img/p2.01bacf53.svg";